// extracted by mini-css-extract-plugin
export default {"canvas":"Signature_canvas__xfeE6"};